import { Component, OnInit } from '@angular/core';
import {environment} from "../../../environments/environment";
import { SourceAuthoritesAfterAuthenticationService } from 'src/app/services/auth/source-authorites-after-authentication.service';
import { ConfigurationService } from 'src/app/services/configuration.service';

@Component({
  selector: 'app-demande-analyse-devis',
  templateUrl: './demande-analyse-devis.component.html',
  styleUrls: ['./demande-analyse-devis.component.scss']
})
export class DemandeAnalyseDevisComponent implements OnInit {

  constructor(private readonly _: SourceAuthoritesAfterAuthenticationService, private configurationService: ConfigurationService) { }
  configuration= this.configurationService.get();
  fileLimit=3;
  fileMaxSize=2000000 //2Mo
  pjRequired=true
  fileAccept="image/png,image/jpeg,image/jpg,application/pdf"
  messageRequired=false
  fileNamePattern = new RegExp(this.configurationService.get().global.fileNamePattern);


  ngOnInit(): void {
  }

}
